import { APP_BASE_HREF } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule, Routes } from '@angular/router';
import { NgIdleModule } from '@ng-idle/core';
import { Keepalive, NgIdleKeepaliveModule } from '@ng-idle/keepalive';
import { IdleSessionModule } from '@ucdhs-ais/ais-ng-library-ng11-png11/src/lib/idle-session';
import { NgHcaptchaModule } from 'ng-hcaptcha';
import { CaptchaModule } from 'primeng/captcha';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { KeyFilterModule } from 'primeng/keyfilter';
import { environment } from 'src/environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CoreModule } from './core/core.module';
import { ViewFormComponent } from './manage-forms/components/view-form/view-form.component';

const appRoutes: Routes = [
  { path: '', component: AppComponent },
  { path: 'view-form', component: ViewFormComponent },
];

@NgModule({
  declarations: [AppComponent],
  imports: [
    RouterModule.forRoot(appRoutes),
    BrowserModule,
    FormsModule,
    BrowserAnimationsModule,
    CoreModule,
    AppRoutingModule,
    IdleSessionModule,
    NgIdleModule,
    NgIdleKeepaliveModule,
    KeyFilterModule,
    ConfirmDialogModule,
    CaptchaModule,
    NgHcaptchaModule.forRoot({
      siteKey: environment.HCAPTCHA_KEY,
    }),
  ],
  providers: [
    Keepalive,
    {
      provide: APP_BASE_HREF,
      useValue: '/hsform/',
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
